module.exports = __webpack_public_path__ + "img/IMG_20210217_171704atif - SAE ZHCET.7eb5d9ef.jpg";